import { render, staticRenderFns } from "./fmwhatsapp.vue?vue&type=template&id=1cae3d4a&scoped=true"
import script from "./fmwhatsapp.vue?vue&type=script&lang=js"
export * from "./fmwhatsapp.vue?vue&type=script&lang=js"
import style0 from "./fmwhatsapp.vue?vue&type=style&index=0&id=1cae3d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cae3d4a",
  null
  
)

export default component.exports